export const messages: Record<string, string> = {
  // Navigation
  'nav.news': 'News',
  'nav.team': 'Team',

  // Common
  'common.save': 'Speichern',
  'common.saving': 'Wird gespeichert...',
  'common.cancel': 'Abbrechen',
  'common.back': 'Zurück',
  'common.edit': 'Bearbeiten',
  'common.delete': 'Löschen',
  'common.loading': 'Lade...',
  'common.publish': 'Veröffentlichen',
  'common.publishing': 'Wird gespeichert…',

  // News
  'news.title': 'Artikel',
  'news.new': 'Neuer Artikel',
  'news.create': 'Artikel verfassen',
  'news.edit': 'Artikel bearbeiten',
  'news.empty': 'Noch keine Artikel vorhanden.',
  'news.loadError': 'Fehler beim Laden der Artikel',
  'news.saveSuccess': 'Artikel erfolgreich gespeichert.',
  'news.saveError': 'Fehler beim Speichern: {message}',
  'news.publishError': 'Fehler beim Veröffentlichen: {message}',
  'news.category': 'Kategorie',
  'news.categoryPlaceholder': 'Wähle eine Kategorie aus',
  'news.titleLabel': 'Titel',
  'news.titlePlaceholder': 'Titel deines Artikels',
  'news.titleInput': 'Titel eingeben*',
  'news.shortDescription': 'Kurzbeschreibung Artikel',
  'news.shortDescriptionLabel': 'Kurzbeschreibung*',
  'news.shortDescriptionPlaceholder':
    'Fasse kurz zusammen, um was es in deinem Artikel gehen wird.',
  'news.category.news': 'News',
  'news.category.events': 'Events',
  'news.category.updates': 'Updates',

  // Team
  'team.title': 'Teammitglieder',
  'team.new': 'Neues Mitglied',
  'team.create': 'Teammitglied erfassen',
  'team.edit': 'Teammitglied bearbeiten',
  'team.empty': 'Noch keine Teammitglieder vorhanden.',
  'team.loadError': 'Fehler beim Laden der Teammitglieder',
  'team.saveSuccess': 'Teammitglied erfolgreich gespeichert.',
  'team.updateSuccess': 'Änderungen gespeichert.',
  'team.saveError': 'Fehler beim Speichern: {message}',
  'team.name': 'Name',
  'team.namePlaceholder': 'Name eingeben',
  'team.group': 'Team',
  'team.groupPlaceholder': 'Job Group auswählen',
  'team.level': 'Ausbildungsstand',
  'team.levelPlaceholder': 'Level auswählen',
  'team.role': 'Rolle',
  'team.rolePlaceholder': 'Job auswählen',
  'team.expirationDate': 'Ablaufdatum',
  'team.expirationDatePlaceholder': 'Datum auswählen',
  'team.expirationLabel': 'bis {date}',
};
